import { initializeApp, FirebaseApp } from "firebase/app";
import { getFirestore, Firestore } from "firebase/firestore";
import {
  getAuth,
  Auth,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  User,
} from "firebase/auth";

/**
 * Firebase client config.
 *
 * These are public identifiers, not secrets — they ship in the JS bundle by
 * design. Access is controlled by Firestore security rules: notices are
 * readable by anyone and writable only by a signed-in admin.
 */
const firebaseConfig = {
  apiKey: "AIzaSyCzRSv222T0DnWTuNDa22umu9Q4urPzeqI",
  authDomain: "cvt-swap.firebaseapp.com",
  projectId: "cvt-swap",
  storageBucket: "cvt-swap.firebasestorage.app",
  messagingSenderId: "321501171057",
  appId: "1:321501171057:web:1bd19a045d6ec2ba04fad0",
};

let app: FirebaseApp | null = null;
let firestore: Firestore | null = null;
let auth: Auth | null = null;

function getApp(): FirebaseApp | null {
  try {
    app = app ?? initializeApp(firebaseConfig);
    return app;
  } catch (error) {
    console.error("[firebase] initialisation failed", error);
    return null;
  }
}

/**
 * Lazily initialise Firestore. Returns null on failure so a Firebase outage
 * degrades to "no notices" rather than breaking the app.
 */
export function getDb(): Firestore | null {
  if (firestore) return firestore;
  const a = getApp();
  if (!a) return null;
  try {
    firestore = getFirestore(a);
    return firestore;
  } catch (error) {
    console.error("[firebase] firestore unavailable", error);
    return null;
  }
}

export function getAuthClient(): Auth | null {
  if (auth) return auth;
  const a = getApp();
  if (!a) return null;
  try {
    auth = getAuth(a);
    return auth;
  } catch (error) {
    console.error("[firebase] auth unavailable", error);
    return null;
  }
}

export async function adminSignIn(email: string, password: string): Promise<void> {
  const client = getAuthClient();
  if (!client) throw new Error("Firebase Auth unavailable.");
  await signInWithEmailAndPassword(client, email, password);
}

export async function adminSignOut(): Promise<void> {
  const client = getAuthClient();
  if (client) await signOut(client);
}

/** Subscribe to sign-in state. Returns an unsubscribe function. */
export function watchAdmin(cb: (user: User | null) => void): () => void {
  const client = getAuthClient();
  if (!client) {
    cb(null);
    return () => {};
  }
  return onAuthStateChanged(client, cb);
}

/** Firestore collection holding site-wide notices. */
export const NOTICES_COLLECTION = "notices";

/** Deep link to the collection in the Firebase console. */
export const NOTICES_CONSOLE_URL = `https://console.firebase.google.com/project/${firebaseConfig.projectId}/firestore/databases/-default-/data/~2F${NOTICES_COLLECTION}`;
